/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EsitoSincronizzazionePraticheDTO } from '../model/esitoSincronizzazionePraticheDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SincronizzazioniService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette di avviare un aggiornamento dello stato dei pagamenti verso pagopa.
     * Interroga PagoPA per aggiornare lo stato corrente dei dovuti (posizioni debitorie) relativi al comune specificato.
     * @param slugComune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkStatoDovuti(slugComune: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public checkStatoDovuti(slugComune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public checkStatoDovuti(slugComune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public checkStatoDovuti(slugComune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling checkStatoDovuti.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/sincronizzazioni/stato-dovuti`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricalcolare tutte le rendicontazioni mensili.
     * Ricalcola le rendicontazioni mensili per il comune e il mese specificati. È possibile fornire una data finale opzionale per filtrare le ricariche considerate nel calcolo.
     * @param slugComune 
     * @param mese 
     * @param dataFinale Data finale opzionale per filtrare le ricariche (formato YYYY-MM-DD)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ricalcolaRendicontazioniMese(slugComune: string, mese: number, dataFinale?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public ricalcolaRendicontazioniMese(slugComune: string, mese: number, dataFinale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public ricalcolaRendicontazioniMese(slugComune: string, mese: number, dataFinale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public ricalcolaRendicontazioniMese(slugComune: string, mese: number, dataFinale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling ricalcolaRendicontazioniMese.');
        }

        if (mese === null || mese === undefined) {
            throw new Error('Required parameter mese was null or undefined when calling ricalcolaRendicontazioniMese.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (mese !== undefined && mese !== null) {
            queryParameters = queryParameters.set('mese', <any>mese);
        }
        if (dataFinale !== undefined && dataFinale !== null) {
            queryParameters = queryParameters.set('dataFinale', <any>dataFinale);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/sincronizzazioni/ricalcola-rendicontazioni`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di rigenerare i dovuti per un comune ed un determinato mese.
     * Rigenera le posizioni debitorie PagoPA per il comune e il mese specificati. Restituisce la lista degli ID dei dovuti rigenerati.
     * @param slugComune 
     * @param mese 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rigeneraDovutiMese(slugComune: string, mese: number, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public rigeneraDovutiMese(slugComune: string, mese: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public rigeneraDovutiMese(slugComune: string, mese: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public rigeneraDovutiMese(slugComune: string, mese: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling rigeneraDovutiMese.');
        }

        if (mese === null || mese === undefined) {
            throw new Error('Required parameter mese was null or undefined when calling rigeneraDovutiMese.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (mese !== undefined && mese !== null) {
            queryParameters = queryParameters.set('mese', <any>mese);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('put',`${this.basePath}/api/v1/sincronizzazioni/rigenera-dovuti`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di avviare una sincronizzazione delle pratiche con il portale gestione pratiche.
     * Avvia la sincronizzazione delle pratiche comunali con il portale GestionePratiche. Se viene fornito il parametro slugComune, sincronizza solo le pratiche del comune specificato; altrimenti sincronizza tutti i comuni.
     * @param slugComune Slug del comune (opzionale). Se specificato, sincronizza solo le pratiche di questo comune
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startSincronizzazione(slugComune?: string, observe?: 'body', reportProgress?: boolean): Observable<EsitoSincronizzazionePraticheDTO>;
    public startSincronizzazione(slugComune?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EsitoSincronizzazionePraticheDTO>>;
    public startSincronizzazione(slugComune?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EsitoSincronizzazionePraticheDTO>>;
    public startSincronizzazione(slugComune?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EsitoSincronizzazionePraticheDTO>('put',`${this.basePath}/api/v1/sincronizzazioni/pratiche`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di sincronizzare una singola pratica specificando il codice pratica.
     * Recupera una singola pratica accettata dal portale GestionePratiche e la sincronizza nel sistema. Crea o aggiorna User, Anagrafica e Studenti associati. Non aggiorna il timestamp di ultima sincronizzazione bulk.
     * @param codicePratica Codice univoco della pratica da sincronizzare
     * @param slugComune Slug del comune
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startSincronizzazioneSingolaPratica(codicePratica: string, slugComune: string, observe?: 'body', reportProgress?: boolean): Observable<EsitoSincronizzazionePraticheDTO>;
    public startSincronizzazioneSingolaPratica(codicePratica: string, slugComune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EsitoSincronizzazionePraticheDTO>>;
    public startSincronizzazioneSingolaPratica(codicePratica: string, slugComune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EsitoSincronizzazionePraticheDTO>>;
    public startSincronizzazioneSingolaPratica(codicePratica: string, slugComune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (codicePratica === null || codicePratica === undefined) {
            throw new Error('Required parameter codicePratica was null or undefined when calling startSincronizzazioneSingolaPratica.');
        }

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling startSincronizzazioneSingolaPratica.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EsitoSincronizzazionePraticheDTO>('put',`${this.basePath}/api/v1/sincronizzazioni/pratiche/${encodeURIComponent(String(codicePratica))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
